import React from "react";
import {
  coupleNames,
  type WeddingLanguage,
  weddingContent,
} from "./content";

interface FooterProps {
  language: WeddingLanguage;
}

export function Footer({ language }: FooterProps) {
  const content = weddingContent[language].footer;
  const sectionLinks =
    language === "vi"
      ? [
          { label: "Câu chuyện", targetId: "story" },
          { label: "Thông tin", targetId: "details" },
          { label: "Lịch trình", targetId: "schedule" },
          { label: content.sendWishes, targetId: "wishes" },
          // { label: "Khoảnh khắc", targetId: "gallery" },
        ]
      : [
          { label: "Our Story", targetId: "story" },
          { label: "Details", targetId: "details" },
          { label: "Timeline", targetId: "schedule" },
          { label: content.sendWishes, targetId: "wishes" },
          // { label: "Our Moments", targetId: "gallery" },
        ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToSection = (targetId: string) => {
    document.getElementById(targetId)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <footer className="wedding-footer">
      <div className="wedding-footer__container">
        <h2 className="wedding-footer__names">{coupleNames}</h2>
        <div className="wedding-divider wedding-footer__divider" />

        <div className="wedding-footer__details">
          <p className="wedding-footer__date">{content.date}</p>
          <p className="wedding-footer__location">{content.location}</p>
        </div>

        <p className="wedding-footer__message">{content.message}</p>

        <div className="wedding-footer__links">
          <button onClick={scrollToTop} className="wedding-footer__button">
            {content.backToTop}
          </button>
          {sectionLinks.map((link) => (
            <React.Fragment key={link.targetId}>
              <span className="wedding-footer__separator">&bull;</span>
              <button
                onClick={() => scrollToSection(link.targetId)}
                className="wedding-footer__button"
              >
                {link.label}
              </button>
            </React.Fragment>
          ))}
        </div>

        <div className="wedding-footer__bottom">
          <p className="wedding-footer__copyright">{content.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
